import styled from "styled-components";

import { Star } from "@ui/Assets/MyIcons";
import { text } from "@ui/helpers";

export const Rating = styled.div`
  position: absolute;
  bottom: -107px;
  right: -137px;
  width: 358px;
  height: 358px;
  color: transparent;
  z-index: 0;

  ${props => props.theme.breakpointsV2.smallTablet} {
    bottom: -103px;
    right: -154px;
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    bottom: -61px;
    right: -199px;
  }
`;

export const RatingLabel = styled.span`
  position: absolute;
  top: 55px;
  left: -55px;
  font-size: 128px;
  font-weight: ${props => props.theme.fontWeights[700]};
  line-height: normal;
  letter-spacing: -1.28px;
  color: ${props => props.theme.palette.white};
  white-space: nowrap;
  z-index: 1;

  ${props => props.theme.breakpointsV2.smallTablet} {
    ${text("bold_64")}

    top: 152px;
    left: 17px;
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    top: 111px;
    left: -97px;
    font-size: 128px;
    font-weight: ${props => props.theme.fontWeights[700]};
    line-height: normal;
    letter-spacing: -1.28px;
  }
`;

export const StarIcon = styled(Star).attrs(props => ({
  fill: props.theme.palette.yellow500,
}))`
  position: absolute;
  inset: 0;
  min-width: 100%;
  min-height: 100%;
  z-index: 0;
`;
